///var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/components/mlmOrg/EditSponsorDialog.js
import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

import { API_URLS } from '../../api/api';
import { getSelectedLanguage } from '../../api/api';        // NEW
import { languageManager } from '../../utils/loadLanguage'; // NEW

const EditSponsorDialog = ({ visible, onHide, userId }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // State สำหรับค่าปัจจุบันจาก API 
    const [userTeamId, setUserTeamId] = useState(null);
    const [originalSponsorId, setOriginalSponsorId] = useState(null);
    const [originalPosition, setOriginalPosition] = useState(null);

    // State สำหรับค่าที่ผู้ใช้แก้ไข
    const [newTeam, setNewTeam] = useState('');
    const [newCommission, setNewCommission] = useState('');

    // state สำหรับข้อความใน JSON (ภายใต้ orgChartComponent)
    const [t, setT] = useState({});

    // โหลดภาษา
    useEffect(() => {
        async function loadLang() {
            const lang = getSelectedLanguage(); // e.g. 'en' or 'th'
            await languageManager.loadLanguage(lang);
            setT(languageManager.translations.orgChartComponent || {});
        }
        loadLang();
    }, []);

    useEffect(() => {
        if (visible && userId) {
            fetchCurrentData(userId);
        }
    }, [visible, userId]);

    // ดึงข้อมูลจาก SPONSOR_VIEW
    const fetchCurrentData = async (uId) => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            const resp = await fetch(API_URLS.SPONSOR_VIEW(uId), {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!resp.ok) {
                throw new Error(`Failed to fetch sponsor data (status: ${resp.status})`);
            }
            const data = await resp.json();
            console.log('Sponsor data for editing =>', data);

            if (Array.isArray(data) && data.length > 0) {
                const row = data[0];
                setUserTeamId(row.user_team_id);
                setOriginalSponsorId(row.sponsor_id);
                setOriginalPosition(row.position_ID);

                setNewTeam(row.team_id || '');
                setNewCommission(row.commission_rate || '');
            } else {
                // ถ้าไม่พบข้อมูล
                setUserTeamId(null);
                setOriginalSponsorId(null);
                setOriginalPosition(null);
                setNewTeam('');
                setNewCommission('');
            }
        } catch (err) {
            console.error('fetchCurrentData error:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // ฟังก์ชันบันทึกข้อมูล
    const handleSave = async () => {
        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem('token');
            const body = [
                {
                    user_team_id: userTeamId, 
                    new_team_id: newTeam,
                    new_sponsor_id: originalSponsorId,
                    new_position: originalPosition,
                    new_commission_rate: parseFloat(newCommission) || 0
                }
            ];

            console.log('UPDATE_SPONSOR Request =>', {
                url: API_URLS.UPDATE_SPONSOR(),
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body
            });

            const resp = await fetch(API_URLS.UPDATE_SPONSOR(), {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(body)
            });

            console.log('UPDATE_SPONSOR Response status:', resp.status, resp.statusText);

            let responseBody = null;
            try {
                responseBody = await resp.json();
                console.log('UPDATE_SPONSOR Response Body:', responseBody);
            } catch (jsonError) {
                console.warn('Cannot parse JSON response:', jsonError);
            }

            if (!resp.ok) {
                throw new Error(responseBody?.message || (t.updateFailed || 'Failed to update sponsor'));
            }

            console.log(t.updateSuccess || 'Update success');
            onHide();
        } catch (err) {
            console.error('Error updating sponsor:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const footer = (
        <div style={{ textAlign: 'right' }}>
            <Button
                label={t.btnCancel || "Cancel"}
                className="p-button-text p-button-danger"
                onClick={onHide}
                disabled={loading}
            />
            <Button
                label={t.btnSave || "Save"}
                className="p-button-text p-button-success"
                onClick={handleSave}
                disabled={loading}
            />
        </div>
    );

    return (
        <Dialog
            header={t.editSponsorHeader || "Edit Sponsor"}
            visible={visible}
            style={{ width: '30vw' }}
            onHide={onHide}
            footer={footer}
        >
            {loading && <div>{t.loading || "LOADING..."}</div>}
            {error && <div style={{ color: 'red' }}>{error}</div>}

            <div className="p-fluid">
                <div className="field">
                    <label>{t.labelTeam || "Team"}</label>
                    <InputText
                        value={newTeam}
                        onChange={(e) => setNewTeam(e.target.value)}
                        disabled={loading}
                    />
                </div>

                <div className="field">
                    <label>{t.labelCommission || "Commission"}</label>
                    <InputText
                        value={newCommission}
                        onChange={(e) => setNewCommission(e.target.value)}
                        disabled={loading}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default EditSponsorDialog;
